import { AuditAudio } from '@mi-front/core';
import {
  auditSpotAuditSpotMediaList,
  auditSpotAuditSpotMediaTranscription,
} from '@mi-front/api-v2';
import { useQuery } from '@tanstack/react-query';

/**
 * Loads the creative/script transcription for an audit audio via api-v2.
 * Uses the preloaded value when available; otherwise resolves media by customId
 * and fetches `/audit-spot/v1/media/:id/transcription`.
 */
export function useAuditAudioTranscription(
  stationId: string,
  customId: string | undefined,
  alreadyLoaded: AuditAudio['transcription'] | undefined,
  enabled: boolean,
) {
  return useQuery({
    queryKey: ['audit-audio-transcription', stationId, customId],
    queryFn: async (): Promise<AuditAudio['transcription'] | null> => {
      if (!customId) {
        return null;
      }

      const list = await auditSpotAuditSpotMediaList({
        station: stationId,
        filter: [`customId||$eq||${customId}`],
        limit: 1,
      });
      const mediaId = list.data[0]?.id;
      if (!mediaId) {
        return null;
      }

      const transcription = await auditSpotAuditSpotMediaTranscription(mediaId);
      return transcription as unknown as AuditAudio['transcription'];
    },
    enabled: enabled && !!customId && !alreadyLoaded?.content,
    initialData: alreadyLoaded?.content ? alreadyLoaded : undefined,
    staleTime: 5 * 60 * 1000,
  });
}
